const mainMenus = [
  // {
  //   label: 'Campaign策划智能体',
  //   icon: 'images/menuIcon/home.png',
  //   activeIcon: 'images/menuIcon/homeActive.png',
  //   activePath: '/agentCluster',
  //   activePaths: ['/agentCluster'],
  //   path: '/agentCluster/input/MARKETING_EVENT_CLUSTER/agent_cluster/marketing_event_cluster',
  //   showPosition: 'menu',
  //   permissionsKey: 'agentCluster',
  //   children: []
  // },
  {
    label: '营销物料制作智能体',
    icon: 'images/menuIcon/writingAgent.png',
    activeIcon: 'images/menuIcon/writingAgentActive.png',
    activePath: '/offerAgentPlaza',
    activePaths: ['/offerAgentPlaza', '/writingAgent', '/videoAgent', '/designAgent'],
    path: '/offerAgentPlaza',
    showPosition: 'menu',
    permissionsKey: 'offerAgentPlaza',
    children: []
  },
  // {
  //   label: '营销“龙虾”广场',
  //   icon: 'images/menuIcon/icon8.png',
  //   activeIcon: 'images/menuIcon/icon8A.png',
  //   activePath: '/lobsterPlaza',
  //   activePaths: ['/lobsterPlaza'],
  //   path: '/lobsterPlaza',
  //   showPosition: 'menu',
  //   permissionsKey: 'lobsterPlaza',
  //   children: []
  // },
  {
    label: '企业营销数字资产管理',
    icon: 'images/menuIcon/brandVoice.png',
    activeIcon: 'images/menuIcon/brandVoiceActive.png',
    activePath: '/brandStandard',
    activePaths: ['/brandStandard', '/brandVoice', '/knowledge', '/enterpriseModel'],
    path: '/brandStandard',
    showPosition: 'menu',
    permissionsKey: 'brandStandard',
    children: []
  }
]

const accountMenus = [
  {
    label: '个人中心',
    icon: 'images/menuIcon/brain.png',
    activeIcon: 'images/menuIcon/brainActive.png',
    activePath: '/user',
    path: '/user/userSetting',
    showPosition: 'dropdown',
    permissionsKey: 'user',
    children: [
      {
        label: '基本设置',
        type: 'root',
        activePath: '/user/userSetting',
        routeName: 'UserSetting',
        permissionsKey: 'userSetting'
      },
      {
        label: '安全设置',
        type: 'root',
        activePath: '/user/userSafe',
        routeName: 'UserSafe',
        permissionsKey: 'userSafe'
      },
      {
        label: '我的套餐',
        type: 'root',
        activePath: '/user/combo',
        routeName: 'combo',
        permissionsKey: 'combo'
      },
      {
        label: '消耗日志',
        type: 'root',
        activePath: '/user/consumption',
        routeName: 'consumption',
        permissionsKey: 'consumption'
      }
    ]
  },
  {
    label: '下载中心',
    icon: 'images/menuIcon/dropdown.png',
    activeIcon: 'images/menuIcon/dropdownActive.png',
    activePath: '/download',
    path: '/download/index',
    showPosition: 'dropdown',
    permissionsKey: 'download',
    children: []
  },
  {
    label: '团队中心',
    icon: 'images/menuIcon/brain.png',
    activeIcon: 'images/menuIcon/brainActive.png',
    activePath: '/team',
    path: '/team/teamPackage',
    showPosition: 'dropdown',
    permissionsKey: 'team',
    children: []
  }
]

export const menuList = [...mainMenus, ...accountMenus]
export const newMenuList = [...mainMenus, ...accountMenus]
